import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { addLocation } from '../../websocket';

function NewLocation({ stock, defaultWarehouse, locations }) {
	const [id, setId] = useState('');
	const [warehouse, setWarehouse] = useState(defaultWarehouse);
	const [redirect, setRedirect] = useState(false);
	const whValues = useMemo(() => {
		const out = {};
		Object.values(locations).forEach(key => {
			out[key] = true;
		});
		return Object.keys(out).map(label => ({ value: label, label }));
	}, [locations]);

	if(redirect) {
		return <Redirect to="/" push={true} />;
	}
	const wh = whValues.find(w => w.value === warehouse);
	return <section className="container">
		<h1>Nieuwe locatie</h1>
		<form onSubmit={e => {
			e.preventDefault();
			addLocation(id, warehouse);
			setRedirect(true);
		}}>
			<div className="form-group">
				<input
					type="text"
					className="form-control"
					placeholder="Code"
					value={id}
					onChange={e => setId(e.target.value.toUpperCase())}
					required />
			</div>
			<div className="form-group">
				<select className="form-control" onChange={e => setWarehouse(e.target.value)} value={warehouse}>
					{whValues.map(w => <option value={w.value} key={w.value}>{w.label}</option>)}
				</select>
			</div>
			<div className="form-group">
				<input
					type="submit"
					className="btn btn-primary"
					value="Save"
					disabled={!id || !wh || stock.find(({ _id }) => id === _id)} />
			</div>
		</form>
	</section>;
}

export default connect(({ stock, warehouse, locations }) => {
	return { stock, defaultWarehouse: warehouse, locations };
})(NewLocation);
